;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/SplitButtnMenu',["jquery", "eventManager", 'loglevel'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel')) :
    console && console.error('SplitButtonMenu does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function SplitButtonMenu(scope, clickMessagesTransmitting, stateChangeMessages, onShowMessagesTransmitter, onHideMessageTransmitter) {
        var self = this;
        Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });


        //#region click messages transmitting registration
        if (clickMessagesTransmitting.length) {
            this.$scope.on("click", "button", function() {
                clickMessagesTransmitting.forEach(function(eventName) {
                    log.debug("SplitButtonMenu raises message: \'%s\'", eventName);

                    eventManager.trigger(eventName, self);
                });

                return 1;
            });
        }
        //#endregion

        //#region state change message transmitter registration
        if (stateChangeMessages.length) {
            this.$scope.on("shown.bs.dropdown hidden.bs.dropdown", function () {
                stateChangeMessages.forEach(function (eventName) {
                    log.debug("SplitButtonMenu raises message: \'%s\'", eventName);

                    eventManager.trigger(eventName, self);
                });

                return !1;
            });
        }
        //#endregion

        //#region on show message transmitter registration
        if (onShowMessagesTransmitter.length) {
            this.$scope.on("shown.bs.dropdown", function() {
                onShowMessagesTransmitter.forEach(function(eventName) {
                    log.debug("SplitButtonMenu raises message: '%s'", eventName);

                    eventManager.trigger(eventName, self);
                });

                return !1;
            });
        }
        //#endregion

        //#region on hide message transmitter registration
        if (onHideMessageTransmitter.length) {
            this.$scope.on("hidden.bs.dropdown", function() {
                onHideMessageTransmitter.forEach(function(eventName) {
                    log.debug("SplitButtonMenu rauses message: '%s'", eventName);

                    eventManager.trigger(eventName, self);
                });

                return !1;
            });
        }
        //#endregion

    }

    SplitButtonMenu.init = function init(args) {
        return args.IsEditorEditing === true
            ? null
            : new SplitButtonMenu(args.scope,
                                  args.ClickMessagesTransmitting || [],
                                  args.StateChangeMessagesTransmitting || [],
                                  args.ShowMessagesTransmitting || [],
                                  args.HideMessagesTransmitting || []);
    };

    return SplitButtonMenu;
}));
